import React from "react";
import { useReveal } from "../hooks/useReveal";

const ServiceCard = ({ icon, name, text, index }) => {
  const [ref, visible] = useReveal();
  const delayClass = `reveal-delay-${Math.min(index + 1, 6)}`;
  return (
    <div
      ref={ref}
      className={`col-md-4 reveal ${delayClass} ${visible ? "is-visible" : ""}`}
    >
      <i className={icon}></i>
      <div className="service-desc">
        <h3>{name}</h3>
        <p>{text}</p>
      </div>
    </div>
  );
};

export const Services = (props) => {
  const [titleRef, titleVisible] = useReveal();
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div
          ref={titleRef}
          className={`section-title reveal ${titleVisible ? "is-visible" : ""}`}
        >
          <h2>Industries &amp; Solutions</h2>
          <p>
            From property management to healthcare and finance — we ship AI that fits your industry,
            your data, and your compliance needs.
          </p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <ServiceCard key={`${d.name}-${i}`} index={i} {...d} />
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
